import Swal from 'sweetalert2'

export default () => {

    const success = (message) => {
        Swal.fire({
            timer: 2000,
            timerProgressBar: true,
            showConfirmButton: false,
            title: 'Bien hecho',
            text: message,
            icon: 'success',
            backdrop: 'rgba(255, 255, 255, 0.8)',
        })
    }

    const info = (message) => {
        Swal.fire({
            timer: 2000,
            timerProgressBar: true,
            showConfirmButton: false,
            text: message,
            icon: 'info',
            backdrop: 'rgba(255, 255, 255, 0.8)',
        })
    }

    const error = (message) => {
        Swal.fire({
            timer: 2000,
            timerProgressBar: true,
            showConfirmButton: false,
            title: 'Error',
            text: message,
            icon: 'error',
            backdrop: 'rgba(255, 255, 255, 0.8)',
        })
    }

    const confirm = (message, funcion) => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: message,
            showDenyButton: true,
            confirmButtonText: `Confirmar`,
            confirmButtonColor: '#03662e',
            denyButtonText: `Cancelar`,
            denyButtonColor: 'red',
            icon: 'warning',
            backdrop: 'rgba(255, 255, 255, 0.8)',
        }).then((result) => {
            if (result.isConfirmed) {
                funcion()
            } else if (result.isDenied) {
                info('Accion cancelada')
            }
        });
    }

    return {
        success,
        info,
        error,
        confirm
    }
}